import React from 'react';
import { motion } from 'framer-motion';
const mockupUrl = 'https://cdn.magicpatterns.com/patterns/generated-images/bdce1584-127d-49e6-8205-c7122adc97ef.jpg';
export function MockupReminder() {
  return <section className="w-full bg-white px-4 pb-4 pt-16 sm:px-6 sm:pt-24" data-id="element-113" data-mp="10ay885g2242h">
      <motion.figure initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.55,
      ease: 'easeOut'
    }} className="relative mx-auto w-full max-w-5xl" data-id="element-114" data-mp="151oerm07wcyr">
        <div className="overflow-hidden rounded-[2rem] border border-ink/10 bg-cream shadow-xl" data-id="element-115" data-mp="1o0skaksjvolo">
          <img src={mockupUrl} alt="Zwei Kinder bauen mit MakerLab Roboter aus Karton und Alltagsmaterialien" className="aspect-[4/3] w-full object-contain" data-id="element-116" data-mp="3kt2izm2sxk86" />
        </div>
        <div className="absolute left-4 top-4 rounded-full bg-white px-3.5 py-2 text-xs font-bold text-ink shadow-lg sm:-left-5 sm:top-7" data-id="element-117" data-mp="3vj38n91lztbc">
          🤖 Echte Roboter bauen
        </div>
        <div className="absolute bottom-4 right-4 rounded-full bg-white px-3.5 py-2 text-xs font-bold text-ink shadow-lg sm:-bottom-4 sm:-right-4" data-id="element-118" data-mp="3lsqhuz37b3wr">
          📦 100+ Projekte
        </div>
        <figcaption className="sr-only" data-id="element-119" data-mp="3hpc1267fuji9">
          MakerLab: Kinder bauen gemeinsam kreative Roboter aus einfachen
          Materialien.
        </figcaption>
      </motion.figure>
    </section>;
}